import React, { FC, useEffect } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

interface IProps {
    children: React.ReactNode,
}

const Portal: FC<IProps> = ({ children }) => {
    const portalRoot = document.getElementById('portal-root');
    const portalDiv = document.createElement('div');

    useEffect(() => {
        portalRoot!.appendChild(portalDiv);
        return () => { portalRoot!.removeChild(portalDiv); };
    }, [portalDiv, portalRoot]);

    return createPortal(children, portalDiv);
};

Portal.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Portal;
